import React from "react";
import ACCENT_SECTION_STYLE from "./accentSectionStyle";

const TakingACourseSection = () => (
  <section
    className="faqs"
    id="taking-a-course"
    aria-labelledby="taking-a-course-title"
    style={ACCENT_SECTION_STYLE}
  >
    <div className="container">
      <div className="section-head">
        <span className="section-num">04</span>
        <h2 className="section-title" id="taking-a-course-title">
          Taking a <em>course</em>.
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>How long does each course take?</summary>
          <div className="faq-answer">
            <p>
              All courses are self-paced. As a rough guide,{" "}
              <strong>most learners take 6 to 9 hours of learning time</strong>{" "}
              across roughly 2 weeks. If you put your head down, all courses can
              be completed in under 20 hours.
            </p>
            <p>
              Lessons are 15 to 20 minutes, so easy to fit between meetings or
              on a commute. Your progress is saved automatically. Stop and start
              whenever you like.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What's the pass mark?</summary>
          <div className="faq-answer">
            <p>
              <strong>75% across the course.</strong> You're given lives (like
              in a video game) to retake lessons you don't get right first time.
              We're less interested in whether you're strictly "right or wrong"
              and more interested in your thinking, your ideas, and your effort.
              We're here to help you build confidence, not catch you out.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What happens if I fail the course?</summary>
          <div className="faq-answer">
            <p>
              You can retake it from scratch. Failure isn't fatal. Most people
              who don't pass first time pass comfortably the second time around
              because they already know how the assessments work.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Are 42courses certificates accredited?</summary>
          <div className="faq-answer">
            <p>
              Yes. <strong>Every course is CPD-accredited.</strong> When you
              pass, you receive a personalised, signed and dated trackable
              certificate that's easy to print or share online. CPD hours count
              toward continuing professional development requirements across
              marketing, advertising, financial services, consulting, and most
              other professional industries.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Can I add my certificate to LinkedIn?</summary>
          <div className="faq-answer">
            <p>
              Yes. We provide a one-click "Add to LinkedIn" option once you
              complete a course, and you can also download a PDF for printing or
              attaching to your CV.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>
            How does a 42courses certification compare with a university
            qualification?
          </summary>
          <div className="faq-answer">
            <p>
              The training is delivered in a more digestible and enjoyable
              format than the traditional academic version.{" "}
              <strong>
                Each course is co-created and taught with industry leaders
              </strong>
              , so you learn real-world tips from people doing the job day in
              and day out, rather than from academics summarising other
              academics.
            </p>
            <p>
              You'll still get links to academic papers where relevant, but you
              don't need to wade through thousands of pages to pass.{" "}
              <strong>
                It's less about academic theory and more about actionable,
                practical insights
              </strong>{" "}
              that you can use right away.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default TakingACourseSection;
